import { Typography } from '@mui/material';

import { SupportLinkByLocale } from '@kamernet/constants/Links';
import { useIntl } from '@kamernet/core/Intl';
import { PageContext } from '@kamernet/core/Page';
import { PageLayout } from '@kamernet/core/PageLayout';
import { CommonStyles } from '@kamernet/styles/CommonStyles';

import styles from './Error500.module.css';

export const Error500 = () => {
  const { T, locale } = useIntl();
  const { traceID } = PageContext.useContext();

  return (
    <PageLayout pageTitle={T('LBL_PAGETITLE_APPLICATION_ERROR')}>
      <PageLayout.MainContainer>
        <PageLayout.SectionContainer className={styles.root}>
          <Typography variant="h1" className={CommonStyles.margin_bottom_2}>
            {500}
          </Typography>
          <div>
            <Typography variant="h3" className={CommonStyles.margin_bottom_2}>
              {T('500_error_page.heading.oops')}
            </Typography>
            <Typography
              variant="body2"
              className={CommonStyles.margin_bottom_2}
            >
              {T('500_error_page.body.tech_difficulties')}
            </Typography>

            <Typography
              className={styles.supportLink}
              variant="body2"
              dangerouslySetInnerHTML={{
                __html: T(
                  '500_error_page.body.tech_difficulties.refresh_page',
                  SupportLinkByLocale[locale],
                ),
              }}
            />
          </div>

          <div className={CommonStyles.margin_top_5}>
            {/* eslint-disable-next-line custom/no-restricted-translation-jsx-untranslated-children-text */}
            <Typography variant="body2">Trace ID: {traceID}</Typography>
          </div>
        </PageLayout.SectionContainer>
      </PageLayout.MainContainer>
    </PageLayout>
  );
};
